import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart';
import type { UpcomingLoadBucket } from '@/types/analytics';
import { formatShortDay } from '@/lib/analytics-format';

interface UpcomingLoadChartProps {
  data: UpcomingLoadBucket[];
}

const chartConfig: ChartConfig = {
  pending_count: { label: 'Pending', theme: { light: 'var(--chart-2)', dark: 'var(--chart-2)' } },
  overdue_count: { label: 'Overdue', theme: { light: 'var(--chart-5)', dark: 'var(--chart-5)' } },
};

export function UpcomingLoadChart({ data }: UpcomingLoadChartProps) {
  const hasLoad = data.some((d) => d.pending_count + d.overdue_count > 0);
  if (!hasLoad) {
    return (
      <div className="flex h-[200px] items-center justify-center text-sm text-muted-foreground">
        No scheduled assignments in the next 14 days
      </div>
    );
  }
  const points = data.map((d) => ({ ...d, label: formatShortDay(d.date) }));
  return (
    <ChartContainer config={chartConfig} className="h-[200px] w-full">
      <BarChart data={points} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <XAxis dataKey="label" tickLine={false} axisLine={false} fontSize={11} />
        <YAxis tickLine={false} axisLine={false} fontSize={11} allowDecimals={false} />
        <ChartTooltip content={<ChartTooltipContent indicator="dot" />} />
        <ChartLegend content={<ChartLegendContent />} />
        <Bar dataKey="pending_count" stackId="a" fill="var(--color-pending_count)" />
        <Bar dataKey="overdue_count" stackId="a" fill="var(--color-overdue_count)" />
      </BarChart>
    </ChartContainer>
  );
}
